module.exports = __webpack_public_path__ + "img/logo-welcare-clinic.40d97d4a.png";